import React from "react";
// import i18n from "i18n";

function SelectLanguage() {
  // const changeLanguage = (lng) => {
  //   localStorage.setItem("language", lng);
  //   i18n.changeLanguage(lng);
  // };

  return (
    <span>
      {/* <span className={"has-addons"}>
        <button
          className={`button is-small ${
            localStorage.getItem("language") === "pt" ? "is-active" : ""
          }`}
          onClick={() => changeLanguage("pt")}
        >
          PT
        </button>
        <button
          className={`button is-small ${
            localStorage.getItem("language") === "en" ||
            !localStorage.getItem("language")
              ? "is-active"
              : ""
          }`}
          onClick={() => changeLanguage("en")}
        >
          EN
        </button>{" "}
      </span> */}
    </span>
  );
}

export default SelectLanguage;
